<template>
    <!-- Content -->
    <section id="content" class="content terms-cont">
        <!-- Content Header -->
        <div class="content-header sub-visual">
            <div class="sub-visual-bg"></div>
            <div class="in-sec">
                <!-- 고도화 Ver1 : br추가 -->
                <div class="tit-wrap centered-c">
                    <h2 class="tit-h2" v-html="$t('sdp.menu.shoptime.head')"></h2>
                </div>
            </div>
        </div>
        <!-- //Content Header -->

        <!-- Content Body -->
        <div class="content-body">
            <!-- 탭전체영역 -->
            <!-- 고도화 ver2 : 속성 id, labelledby 연결 -->
            <div class="tab-type4-wrap in-sec">
                <!-- 메인탭 -->
                <nav class="tab-nav tab-change tab-type6">
                    <ul role="tablist">
                        <li role="presentation" class="is-active"><a href="#tabContentTerms11" role="tab" id="tabNavTerms1" aria-controls="tabContentTerms11" aria-selected="true" aria-expanded="true"><span class="tit">{{ $t("sdp.menu.device.menutop2.01") }}</span></a></li>
                        <li role="presentation"><a href="#tabContentTerms21" role="tab" id="tabNavTerms2" aria-controls="tabContentTerms21" aria-selected="false" aria-expanded="false"><span class="tit">{{ $t("sdp.menu.device.menutop2.02") }}</span></a></li>
                    </ul>
                </nav>
                <!-- //메인탭 -->

                <!-- 탭컨텐트 -->
                <div class="section-body" v-if="loadingYn == 'Y'">
                    <div class="loading-wrap">
                        <div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
                    </div>
                </div>
                <div class="tab-body" v-else>
                    <!-- Tab1_Terms of Use -->
                    <div id="tabContentTerms11" class="tab-content is-active" aria-labelledby="tabNavTerms11">

                        <!-- S : 2021.04.26 Add 홍병기C -->
                        <div class="stTermsSelect">
                            <span class="form-select form-size-md">
								<select v-model="selectedTerms1" name="sTypes" title="">
                                    <template v-for="(terms, index) in terms1List">
									    <option :value="index" v-if="index == 0">{{ $t('sdp.menu.shoptime.history.001') }} : {{ terms.trmsAplyDt }}</option>
									    <option :value="index" v-else>{{ $t('sdp.menu.shoptime.history.002') }} : {{ terms.trmsAplyDt }}</option>
                                    </template>
								</select>
							</span>
                        </div>
                        <!-- E : 2021.04.26 Add 홍병기C -->

                        <div id="shoptimetermsSec11" class="terms-sec-wrap">
                            <template v-for="(terms, index) in terms1List">
                                <div v-if="selectedTerms1 == index" class="terms-sec" v-html="terms.trmsCntt"></div>
                            </template>
                        </div>

                    </div>
                    <!-- //Tab1_Terms of Use -->

                    <!-- Tab2_Privacy Policy -->
                    <div id="tabContentTerms21" class="tab-content" aria-labelledby="tabNavTerms21">

                        <!-- S : 2021.04.26 Add 홍병기C -->
                        <div class="stTermsSelect">
								<span class="form-select form-size-md">
                                    <select v-model="selectedTerms2" name="sTypes" title="">
                                    <template v-for="(terms, index) in terms2List">
									    <option :value="index" v-if="index == 0">{{ $t('sdp.menu.shoptime.history.001') }} : {{ terms.trmsAplyDt }}</option>
									    <option :value="index" v-else>{{ $t('sdp.menu.shoptime.history.002') }} : {{ terms.trmsAplyDt }}</option>
                                    </template>
                                    </select>
								</span>
                        </div>
                        <!-- E : 2021.04.26 Add 홍병기C -->

                        <div id="shoptimetermsSec21" class="terms-sec-wrap">
                            <template v-for="(terms, index) in terms2List">
                                <div v-if="selectedTerms2 == index" class="terms-sec" v-html="terms.trmsCntt"></div>
                            </template>
                        </div>
                    </div>
                    <!-- //Tab2_Privacy Policy -->
                </div>
                <!-- //탭컨텐트 -->
            </div>
            <!-- //탭전체영역 -->
        </div>
        <!-- //Content Body -->
    </section>
    <!-- //Content -->
</template>

<script>
    import qs from "qs";

    export default {
        name: "ShopTime",
        data() {
            return {
                selectedTerms1: "",
                selectedTerms2: "",
                terms1List: [],
                terms2List: [],
                loadingYn: "Y"
            }
        },
        methods: {

        },
        computed: {

        },
        mounted() {
            const vm = this;
            vm.loadingYn = "Y";
            $(window).scrollTop(0);
            ui.loading.open();

            var params = {
                cntryCode: _domainCntryCode,
                langCode: _domainLangCode
            };

            this.$axios.post('/api/terms/retrieveShopTimeTerms.ajax', qs.stringify(params)).then((result) => {
                ui.loading.close();
                vm.terms1List = result.data.terms1List;
                vm.terms2List = result.data.terms2List;
                vm.loadingYn = "N";

                vm.$nextTick(function() {
                    vm.selectedTerms1 = 0;
                    vm.selectedTerms2 = 0;
                    ui.tab.init();
                    loadLabelledby();
                    if ($('.terms-sec span').length){ $('.terms-sec span').removeAttr('style'); }
                });
            }).catch((err) => {
                ui.loading.close();
                vm.loadingYn = "N";
                alert(err);
            });
        }
    }
</script>

<style scoped>

</style>